import { render, staticRenderFns } from "./notifications-editor.vue?vue&type=template&id=0003b076&scoped=true&"
import script from "./notifications-editor.vue?vue&type=script&lang=js&"
export * from "./notifications-editor.vue?vue&type=script&lang=js&"
import style0 from "./notifications-editor.vue?vue&type=style&index=0&id=0003b076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0003b076",
  null
  
)

export default component.exports